<div class="flex items-center justify-between">
  <h2 mat-dialog-title>Manage {{program.name}}'s Sites</h2>
  <mat-icon matRipple style="cursor: pointer; margin-right: 0.5rem" (click)="dialogRef.close()">close</mat-icon>
</div>

<mat-dialog-content>
    <mat-form-field style="width: 100%">
      <mat-label>Select Sites</mat-label>
      <mat-chip-grid #chipList aria-label="Selected Sites">
        @for (site of programSites; track $index) {
          <mat-chip-row (removed)="removeSite(site)">
            {{ siteName(site) }}
            <button matChipRemove [attr.aria-label]="'remove ' + site">
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-row>
        }
      </mat-chip-grid>
      <input
        placeholder="Add Site..."
        #siteInput
        [(ngModel)]="currentSite"
        [matAutocomplete]="auto"
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (matChipInputTokenEnd)="add($event)"
      />
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event); siteInput.value = ''">
          @for (site of filteredSites(); track $index) {
            <mat-option [value]="site.id">
              {{ site.name }}
            </mat-option>
          }
      </mat-autocomplete>
    </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="primary" (click)="dialogRef.close(programSites)">Save</button>
  <button mat-flat-button color="warn" (click)="dialogRef.close()">Cancel</button>
</mat-dialog-actions>
